// NOTE: This file was automatically generated by a script. Do not modify this file manually.
// To regenerate this file, please use `pnpm scripts:microbootstrap-generator job_catalog`
// The command will generate files in the 'frontend/artifacts' folder with the list of files using collections
import { PropsWithChildren } from 'react'

import {
  CollectionBootstrapConfig,
  CollectionsBootstrap as CoreCollectionsBootstrap,
} from 'modules/core/components/CollectionsBootstrap'
import features from 'modules/core/store/collections/features'
import legalEntities from 'modules/core/store/collections/legalEntities'
import users from 'modules/core/store/collections/users'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import employeeGroups from 'modules/employees/store/collections/employeeGroups'
import employees from 'modules/employees/store/collections/employees'
import memberships from 'modules/teams/store/collections/memberships'
import teams from 'modules/teams/store/collections/teams'

const CollectionsBootstrap = ({ children }: PropsWithChildren) => {
  const collections: CollectionBootstrapConfig[] = [
    [contractVersions, {}] /* Referenced by 8 cases in this module */,
    [employeeGroups, {}] /* Referenced by 6 cases in this module */,
    [employees, {}] /* Referenced by 16 cases in this module */,
    [features, {}] /* Referenced by 7 cases in this module */,
    [legalEntities, {}] /* Referenced by 8 cases in this module */,
    [memberships, {}] /* Referenced by 1 cases in this module */,
    [teams, {}] /* Referenced by 1 cases in this module */,
    [users, {}] /* Referenced by 6 cases in this module */,
  ] /* Generated file 👉 artifacts/job_catalog-module-employees.tsx-collection-dependencies-report-v2.json */

  return <CoreCollectionsBootstrap collections={collections}>{children}</CoreCollectionsBootstrap>
}

export default CollectionsBootstrap
